module.exports = __webpack_public_path__ + "static/img/di2.73ace89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/di2.png
// module id = qURO
// module chunks = 1